import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useBankTransaction } from '@/core/composables/useBankTransaction'
import { formatToFinnishCurrency } from '@/helpers/formatters'
import { computed, toRef } from 'vue'

interface Props {
  /** The bank transaction to display */
  transaction: BankTransactionResource
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BankTransactionAmount',
  props: {
    transaction: {}
  },
  setup(__props: any) {



const { isExpense, isIncome } = useBankTransaction(toRef(() => __props.transaction))

const formattedAmount = computed(() =>
  formatToFinnishCurrency(
    isExpense.value ? -__props.transaction.amount : __props.transaction.amount
  )
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["flex flex-row items-center font-medium whitespace-nowrap", _unref(isIncome) ? 'text-success' : 'text-danger'])
  }, _toDisplayString(formattedAmount.value), 3))
}
}

})